/** Width of `MuiListItemIcon` from theme overrides (`list.ts`). */
export const NAV_ITEM_ICON_WIDTH_PX = 25;

/** Default `UserAvatar` size in the vertical nav footer (`regular`). */
export const NAV_ITEM_AVATAR_WIDTH_PX = 40;

/** Gap between icon/avatar and label text — matches `MuiListItemIcon` theme override (`list.ts`). */
export const NAV_ITEM_ICON_LABEL_GAP = 4;

/**
 * Left inset that centers a fixed-width nav icon/avatar in the collapsed drawer.
 * Used for all drawer states so pinning/hover never shifts icons.
 */
export function collapsedNavItemInsetPx(collapsedNavWidth: number, itemWidthPx: number): number {
  return Math.max(0, (collapsedNavWidth - itemWidthPx) / 2);
}

/**
 * Styles that hide nav labels without shifting icon/avatar position.
 * Width collapses instantly; only opacity animates so icons stay put during hover.
 */
export function hiddenNavLabelSx(hideNavLabels: boolean): Record<string, unknown> {
  return hideNavLabels
    ? {
        whiteSpace: 'nowrap',
        opacity: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
        transition: 'opacity .25s ease-in-out',
      }
    : {
        whiteSpace: 'nowrap',
        opacity: 1,
        overflow: 'hidden',
        transition: 'opacity .25s ease-in-out',
      };
}
